// extracted by mini-css-extract-plugin
export default {"buttonContainer":"LoginPage_buttonContainer__pp36M","infoBannerContent":"LoginPage_infoBannerContent__cKEgs"};